import { Argument, createCommand } from '@commander-js/extra-typings';

export const telemetry = () => {
  return createCommand('telemetry')
    .description(
      'Opt in/out of sending anonymous usage information (telemetry) to Wix'
    )
    .addArgument(new Argument('<state>', '').choices(['on', 'off'] as const))
    .action(async (state) => {
      const { updateUserConfig } = await import('@wix/cli-user-config');
      const { CliError, CliErrorCode } = await import('@wix/cli-error');
      const { createLogger } = await import('@wix/cli-logger');

      const logger = createLogger();
      try {
        const telemetryEnabled = state === 'on';
        await updateUserConfig({ telemetry: telemetryEnabled });
        logger.log(`Telemetry has been turned ${state} successfully.`);
      } catch (e) {
        throw new CliError({
          cause: e,
          code: CliErrorCode.FailedToUpdateTelemetryConfig(),
        });
      }
    });
};
